import React from 'react';
import { useLocation } from 'react-router-dom';
import { Box } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => createStyles({
  pageRoot: {
    minHeight: '100vh',
    backgroundColor: '#fff',
    fontFamily: 'Noto Sans JP',
  },
  contentWrapper: {
    maxWidth: '980px',
    margin: '0 auto',
    padding: '0 20px 40px',
  },
  sectionHeaderRoot: {
    borderBottom: '3px solid #B9BEBE',
    paddingBottom: '25px',
    marginBottom: '20px',
    position: 'relative',
    marginTop: '20px',
    '&::after': {
      content: '""',
      position: 'absolute',
      display: 'block',
      borderBottom: 'solid 3px #cd0021',
      bottom: '-3px',
      width: '100px',
    },
  },
  sectionTitle: {
    fontFamily: 'Noto Sans JP',
    fontWeight: 500,
    fontSize: '30px',
    lineHeight: '45px',
    letterSpacing: '0.8px',
    color: '#000000',
    margin: 0,
  },
  content: {
    marginTop: '20px',
    fontSize: '16px',
    color: '#6f7878',
    letterSpacing: '0.05em',
    lineHeight: 1.5,
    wordWrap: 'break-word',
    fontWeight: 500,
    fontFamily: 'Noto Sans JP',
  },
}));

interface LocationState {
  acceptRequestReservation?: boolean;
}

function ReservationChangeCompletePage() {
  const classes = useStyles();
  const location = useLocation<LocationState>();
  const urlParams = new URLSearchParams(location.search);
  const isCancel = urlParams.get('type') === 'cancel';
  const acceptRequestReservation = location.state?.acceptRequestReservation ?? true;

  return (
    <div className={classes.pageRoot}>
      <div className={classes.contentWrapper}>
        <div className={classes.sectionHeaderRoot}>
          <p className={classes.sectionTitle}>{isCancel ? 'キャンセル受付完了' : '受付完了'}</p>
        </div>

        <Box>
          {isCancel && (
            <p className={classes.content}>
              キャンセルの手続きが完了しました。またのご利用をお待ちしております。
            </p>
          )}
          {!isCancel && acceptRequestReservation && (
            <p className={classes.content}>
              予約変更のお申し込みを受け付けました。
              <br />
              24時間以内にお客様がご希望された店舗より、ご予約確認のお電話を差し上げます。
              <br />
              お電話が繋がらない場合は、誠に申し訳ございませんがご予約はキャンセルとなりますのであらかじめご了承願います。
            </p>
          )}
          {!isCancel && !acceptRequestReservation && (
            <p className={classes.content}>
              予約変更を受け付けました。
              <br />
              ご来店をお待ちしております。
            </p>
          )}
        </Box>
      </div>
    </div>
  );
}

export default ReservationChangeCompletePage;
